import { useKeyboardClick } from '@op/react-web'
import cls from 'classnames'
import type { ReactNode } from 'react'
import type { TestIDValue } from '../../TestID'

type ChooseSubSelectBoxProps = {
	readonly children?: ReactNode
	readonly className?: string
	readonly selected: boolean
	readonly testId: TestIDValue
	onSelect(): void
}

export const ChooseSubSelectBox = ({
	children,
	className,
	selected,
	testId,
	onSelect,
}: ChooseSubSelectBoxProps) => {
	const handleClick = useKeyboardClick(() => {
		if (selected) return

		onSelect()
	})

	return (
		<div
			data-testid={testId}
			{...handleClick}
			className={cls(
				'border-2 cursor-pointer flex-1 rounded-3xl min-w-[84%] sm:min-w-[300px] md:max-w-md lg:min-w-[420px] xl:max-w-xl',
				selected && 'border-teal',
				className,
			)}
		>
			{children}
		</div>
	)
}
